import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoService } from "@ngneat/transloco";

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent {
  @Input() searchBarClass: string | undefined;
  @Input() inputValue: string | undefined;
  @Input() placeholder: string = "..."
  @Output() searchQuery: EventEmitter<string> = new EventEmitter();
  isLoading: boolean = false;
  showEmptyState: boolean = false;
  @Input() items: any = [];

  constructor(public translocoService: TranslocoService) {
  }

  onInputChange(event: Event): void {
    this.searchQuery.emit((event.target as HTMLInputElement).value);
  }
}
